import { Route } from "react-router-dom";
import ProtectedRoute from "../ProtectedRoute";

export const renderRoutes = (routes) =>
  routes.map(({ path, element, roles }) => (
    <Route
      key={path}
      path={path}
      element={<ProtectedRoute allowedRoles={roles}>{element}</ProtectedRoute>}
    />
  ));
